<template>
    <div>
        <section>
            <el-col :lg="24" class="case-vote-temp">
                <template>
                    <el-tabs type="card" v-model="activeName" @tab-click="handleClick" class="cust-tabs" v-if="showTabs">
                        <el-tab-pane name="stage_1">
                            <div slot="label" class="tab-panel">
                                <div class="tab-name">
                                    <p class="nm"> {{ $t("Case Details") }}</p>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="stage_2" v-if="$store.state.config.user.role_slug.indexOf('fachstellen') < 0 && caseDetails.status_key != 'stage_3'">
                            <div slot="label" class="tab-panel">
                                <div class="tab-name">
                                    <p class="nm"> {{ $t("Vote Details") }}</p>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="stage_3" class="votes-dev" v-if="$store.state.config.user.role_slug==='main-admin' || $store.state.config.user.role_slug == 'organization' || $store.state.config.user.role_slug == 'organization-user'">
                            <div slot="label" class="tab-panel">
                                <div class="tab-name">
                                    <p class="nm"> {{ $t("Review Details") }}</p>
                                </div>
                            </div>
                            <el-row :gutter="20">
                                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                                    <el-card class="case-card">
                                        <div class="case-detail">
                                            <h4>{{ caseDetails.expected_amount | currency-format }}</h4>
                                            <span class="line"></span>
                                            <p>{{ $t('Expected amount') }}</p>
                                        </div>
                                        <div class="case-img">
                                            <img :src="'/static/case-detail/amount.svg'" alt="hand-image">
                                        </div>
                                    </el-card>
                                </el-col>
                                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                                    <el-card class="vote-card grey">
                                        <div class="vote-detail">
                                            <h4>{{ voteDetails.total_voters }}</h4>
                                            <span class="line grey"></span>
                                            <p>{{ $t('Total voters') }}</p>
                                        </div>
                                        <div class="vote-img">
                                            <img :src="'/static/case-detail/total-vote.svg'" alt="total-vote-image">
                                        </div>
                                    </el-card>
                                </el-col>
                                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                                    <el-card class="vote-card green ">
                                        <div class="vote-detail">
                                            <h4>{{ voteDetails.up_votes }}</h4>
                                            <span class="line green"></span>
                                            <p>{{ $t('Agree') }}</p>
                                        </div>
                                        <div class="vote-img">
                                            <img :src="'/static/case-detail/up-votes.svg'" alt="up-votes-image">
                                        </div>
                                    </el-card>
                                </el-col>
                                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                                    <el-card class="vote-card orange">
                                        <div class="vote-detail">
                                            <h4>{{ voteDetails.down_votes }}</h4>
                                            <span class="line orange"></span>
                                            <p>{{ $t('Not agree') }}</p>
                                        </div>
                                        <div class="vote-img">
                                            <img :src="'/static/case-detail/down-votes.svg'" alt="down-votes-image">
                                        </div>
                                    </el-card>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <div class="btn-row">
                                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                                        <el-button v-if="showbtns && caseDetails.status_key != 'rejected' && caseDetails.status_key != 'donated' && ($store.state.config.user.role_slug == 'main-admin' || $store.state.config.user.role_slug == 'organization' || $store.state.config.user.role_slug == 'organization-user')" type="primary" @click="ApproveDialog = true">{{$t('Go ahead')}}</el-button>
                                        <el-button v-if="showbtns && caseDetails.status_key != 'rejected' && caseDetails.status_key != 'donated' && ($store.state.config.user.role_slug == 'main-admin' || $store.state.config.user.role_slug == 'organization' || $store.state.config.user.role_slug == 'organization-user')" type="danger" @click="rejectCasePopUp()" class="reject">{{$t('Reject case')}}</el-button>
                                        <el-button :disabled="caseDetails.payment_date!='' || caseDetails.status_key == 'rejected'" v-if="showbtns && ($store.state.config.user.role_slug == 'main-admin' || $store.state.config.user.role_slug == 'organization' || $store.state.config.user.role_slug == 'organization-user')" type="primary" @click="PaidPopup = true">{{$t('paid')}}</el-button>
                                    </el-col>

                                    <el-dialog :title="$t('Amount')" :visible.sync="ApproveDialog" @open="appform.approved_amount = caseDetails.expected_amount">
                                        <el-form :model="appform" ref="appformData">
                                            <el-form-item :label="$t('Confirmed amount')" prop="approved_amount" :rules="[{ required: true, message: $t('This field is required')}]">                                                
                                                <div class="el-input el-input-group el-input-group--prepend">
                                                    <div class="el-input-group__prepend">{{ $store.state.config.generalSettings.currency_code }}</div>
                                                    <input v-model="appform.approved_amount" type="text" autocomplete="off" class="el-input__inner" 
                                                    v-mask="{'alias': 'numeric', 'groupSeparator': '\'', 'autoGroup': true, 'digits': 2, 'digitsOptional': false, 'prefix': '', 'placeholder': '0'}">
                                                </div>
                                            </el-form-item>
                                            <el-form-item :label="$t('Description')" prop="remark" :rules="[{ required: true, message: $t('This field is required')}]">
                                                <el-input type="textarea"  :autosize="{ minRows: 2, maxRows: 40}" v-model="appform.remark"></el-input>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-button type="primary" :loading="isLoading" @click="confirmCase('appformData',0)">{{$t('Approve')}}</el-button>
                                                <el-button type="primary" :loading="isLoading" @click="confirmCase('appformData',1)">{{$t('Approve and send email')}}</el-button>
                                                <el-button type="cancel" @click="ApproveDialog = false">{{$t('Cancel')}}</el-button>
                                            </el-form-item>
                                        </el-form>
                                        <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
                                    </el-dialog>                                 
                                    <el-dialog :title="$t('Reject case')" :visible.sync="RejectDialog">
                                        <el-form :model="form" ref="formData">
                                            <el-form-item :label="$t('Description')" prop="remark" :rules="[{ required: true, message: $t('This field is required')}]">
                                                <el-input type="textarea"  :autosize="{ minRows: 2, maxRows: 40}" v-model="form.remark"></el-input>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-button type="primary" :loading="isLoading" @click="rejectCase('formData',0)">{{$t('Reject')}}</el-button>
                                                <el-button type="primary" :loading="isLoading" @click="rejectCase('formData',1)">{{$t('Reject and send email')}}</el-button>
                                                <el-button type="cancel" @click="RejectDialog = false">{{$t('Cancel')}}</el-button>
                                            </el-form-item>
                                        </el-form>
                                        <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
                                    </el-dialog>
                                    <el-dialog :title="$t('paidon')" :visible.sync="PaidPopup" width="20%">
                                        <el-form :model="paidformData" ref="paidData">
                                            <el-form-item :label="$t('payment_date')" prop="payment_date" :rules="[{ required: true, message: $t('This field is required')}]">
                                                <el-date-picker v-model="paidformData.payment_date" type="date" :placeholder="$t('payment_date')"
                                                    value-format="yyyy-MM-dd">
                                                </el-date-picker>
                                            </el-form-item>

                                            <el-form-item>
                                                <el-button type="primary" :loading="isLoading" @click="paidCaseDate('paidData')">{{$t('save')}}</el-button>
                                                <el-button type="cancel" @click="PaidPopup = false">{{$t('Cancel')}}</el-button>
                                            </el-form-item>
                                        </el-form>
                                        <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
                                    </el-dialog>


                                </div>
                            </el-row>
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </el-col>
        </section>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                voteDetails: {},
                caseDetails: {},
                ApproveDialog: false,
                PaidPopup:false,
                RejectDialog: false,
                form: {},
                appform: {
                    approved_amount: null
                },
                paidformData : {
                    payment_date : null,
                },
                activeName: "stage_3",
                isLoading: false,
                showbtns: false,
                showTabs: false
            };
        },
        mounted() {
            request({
                url: "patenkinder-cases/" + this.$route.params.id,
                method: "get",
                params: {}
            }).then(response => {
                this.caseDetails = response.data.data;
                this.showbtns = true;
            });
            request({
                url: "case-vote-details/" + this.$route.params.id,
                method: "get"
            }).then(response => {
                this.voteDetails = response.data.data;
                this.showTabs = true
            });
        },
        methods: {
            handleClick(tab, event) {
                if (tab.name == "stage_1") {
                    this.$router.push({
                        name: "CaseDetails",
                        params: {
                            id: this.$route.params.id
                        }
                    });
                } else if (tab.name == "stage_2") {
                    this.$router.push({
                        name: "CaseVoting",
                        params: {
                            id: this.$route.params.id
                        }
                    });
                } else {
                    this.$router.push({
                        name: "CaseReview",
                        params: {
                            id: this.$route.params.id
                        }
                    });
                }
            },
            confirmCase(formName, isEmail) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.isLoading = true;
                        request({
                            url: "update-case-status",
                            method: "post",
                            data: {
                                case_id: this.$route.params.id,
                                status: "donated",
                                remark: this.appform.remark,
                                approved_amount: this.appform.approved_amount,
                                send: isEmail
                            }
                        }).then(response => {
                            this.$router.push({
                                name: "Cases"
                            });
                            this.$notify({
                                title: this.$t("Success"),
                                message: this.$t("Amount donated!"),
                                type: "success",
                                offset: 50
                            });
                            this.ApproveDialog = false;
                            this.PaidPopup = false,
                            this.isLoading = false;
                            this.$refs[formName].resetFields();
                        }).catch(error => {
                            this.$notify({
                                title: this.$t('Error'),
                                message: error.response.data.message,
                                type: "error",
                                offset: 50
                            });
                            this.isLoading = false;
                        });
                    }
                });
            },
            rejectCase(formName, isEmail) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.isLoading = true;
                        request({
                            url: "update-case-status",
                            method: "post",
                            data: {
                                case_id: this.$route.params.id,
                                status: "rejected",
                                remark: this.form.remark,
                                send: isEmail
                            }
                        }).then(response => {
                            this.$router.push({
                                name: "Cases"
                            });
                            this.$notify({
                                title: this.$t("Success"),
                                message: this.$t("Case rejected!"),
                                type: "success",
                                offset: 50
                            });
                            this.isLoading = false;
                            this.$refs[formName].resetFields();
                        }).catch(error => {
                            this.$notify({
                                title: this.$t('Error'),
                                message: error.response.data.message,
                                type: "error",
                                offset: 50
                            });
                            this.isLoading = false;
                        });
                    }
                });
            },
            paidCaseDate(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.isLoading = true;
                        request({
                            url: "send-payment-date/"+this.$route.params.id,
                            method: "post",
                            data: {
                                payment_date: this.paidformData.payment_date
                            }
                        }).then(response => {
                            this.$router.push({
                                name: "Cases"
                            });
                            this.$notify({
                                title: this.$t("Success"),
                                message: this.$t("Paid Date Case"),
                                type: "success",
                                offset: 50
                            });
                            this.isLoading = false;
                            this.$refs[formName].resetFields();
                        }).catch(error => {
                            this.$notify({
                                title: this.$t('Error'),
                                message: error.response.data.message,
                                type: "error",
                                offset: 50
                            });
                            this.isLoading = false;
                        });
                    }
                });
            },
            rejectCasePopUp() {
                this.$confirm(
                        this.$t("Are you sure want to reject this case?"),
                        this.$t("Warning"), {
                            confirmButtonText: this.$t("Yes"),
                            cancelButtonText: this.$t("No"),
                            type: "warning",
                            cancelButtonClass: "el-button--cancel",
                            confirmButtonClass: "el-button--primary"
                        }
                    )
                    .then(() => {
                        this.RejectDialog = true;
                    })
                    .catch(() => {});
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/Cases/CaseReview.vue